import { defineStore } from "pinia";

// «Comandi manuali attivi» (pannello della barra laterale): se il pannello è aperto e quanti comandi sono ancora in corso. Il pannello
// (`LayoutComandiAttiviPannello`) legge i dati dal server e scrive qui il conteggio, che il pulsante del menu mostra come numero.
export const useComandiAttiviStore = defineStore("comandiAttivi", () => {
  const aperto = ref(false);
  const inCorso = ref(0);

  const apri = () => (aperto.value = true);
  const chiudi = () => (aperto.value = false);
  /** Valori non validi (negativi, non numerici) valgono 0: il numero sul pulsante non deve mai essere sbagliato. */
  const impostaInCorso = (n: number) => (inCorso.value = Number.isFinite(n) && n > 0 ? Math.floor(n) : 0);

  return { aperto, inCorso, apri, chiudi, impostaInCorso };
});
